import firebase from '../firebase'

// TODO: Move all these to lib/auth/index.js
class AuthService {
  static FAIL_CASE_USER_NOT_FOUND = (email, password = '') => ({
    code: 'auth/user-not-found',
    message: 'user not found',
    email,
    password,
  })

  static PROVIDER_EMAIL = 'email'

  static PROVIDER_PASSWORD = 'password'

  static signOut() {
    return firebase.auth().signOut()
  }

  static recoverPassword(email, nextUrl) {
    const host = window.location.href || document.documentURI

    const actionCodeSettings = { url: nextUrl || `${host}/firebase` }

    return firebase
      .auth()
      .sendPasswordResetEmail(email, actionCodeSettings)
      .then((res) => res)
      .catch((e) => e)
  }

  static confirmPasswordReset(code, password) {
    return firebase.auth().confirmPasswordReset(code, password)
  }

  static updateUserInfo(email) {
    return firebase.auth().currentUser.updateEmail(email)
  }

  static verifyPasswordResetCode(code) {
    return firebase.auth().verifyPasswordResetCode(code)
  }
}

export default AuthService
